import axios from '@/libs/api.request'
import config from '@/config'

const monitorBaseUrl = config.baseMonitorUrl + '/api/v1/'

export const getEndpoints = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint_list',
    params: params,
    method: 'get'
  })
}

export const getCounterList = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'counter_list',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const getDefaultCounterList = () => {
  return axios.request({
    url: monitorBaseUrl + 'default_counter_list',
    traditional: true,
    method: 'get'
  })
}

export const getEndpointMonitorData = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint_monitor_data',
    params: params,
    method: 'get'
  })
}

export const getTmpGraph = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'tmp_graph/',
    params: params,
    method: 'get'
  })
}

export const postTmpGraph = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'tmp_graph/',
    data: data,
    method: 'post'
  })
}

export const updateTmpGraph = (data, id) => {
  return axios.request({
    url: monitorBaseUrl + 'tmp_graph/' + id + '/',
    data: data,
    method: 'put'
  })
}

export const deleteTmpGraph = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'tmp_graph/' + id + '/',
    method: 'delete'
  })
}

export const getAllPersonalTmpList = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'all_personal_tmp/',
    params: params,
    method: 'get'
  })
}

export const getPersonalTmp = (id) => {
  let url = monitorBaseUrl + 'personal_tmp/'
  if (id) {
    url += id + '/'
  }
  return axios.request({
    url: url,
    method: 'get'
  })
}

export const ChangePersonalTmp = (data, id) => {
  let url = monitorBaseUrl + 'personal_tmp/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deletePersonalTmp = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'personal_tmp/' + id + '/',
    method: 'delete'
  })
}

export const getPersonalTmpGroup = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'personal_tmp_group/',
    params: params,
    method: 'get'
  })
}

export const ChangePersonalTmpGroup = (data, id) => {
  let url = monitorBaseUrl + 'personal_tmp_group/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deletePersonalTmpGroup = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'personal_tmp_group/' + id + '/',
    method: 'delete'
  })
}

export const personalTmpGroupMerge = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'personal_tmp_group_merge/',
    data: data,
    method: 'post'
  })
}

export const personalTmpGroupAssign = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'personal_tmp_group_assign/',
    data: data,
    method: 'post'
  })
}

export const getAlarmTemplate = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'template/',
    params: params,
    method: 'get'
  })
}

export const detailAlarmTemplate = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'template/' + id + '/',
    method: 'get'
  })
}

export const getAllAlarmTemplate = () => {
  return axios.request({
    url: monitorBaseUrl + 'all_template_list/',
    method: 'get'
  })
}

export const changeAlarmTemplate = (data, id) => {
  let url = monitorBaseUrl + 'template/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteAlarmTemplate = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'template/' + id + '/',
    method: 'delete'
  })
}

export const getAlarmStrategy = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'strategy/',
    params: params,
    method: 'get'
  })
}

export const changeAlarmStrategy = (data, id) => {
  let url = monitorBaseUrl + 'strategy/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteAlarmStrategy = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'strategy/' + id + '/',
    method: 'delete'
  })
}

export const getAlarmMetricDefaultList = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'metric_default_list/',
    params: params,
    method: 'get'
  })
}

export const getAlarmAllUsersList = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'all_users_list/',
    params: params,
    method: 'get'
  })
}

export const getAlarmAllUserGroupList = () => {
  return axios.request({
    url: monitorBaseUrl + 'all_user_group_list/',
    method: 'get'
  })
}

export const getAlarmUserGroup = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'user_group/',
    params: params,
    method: 'get'
  })
}

export const changeAlarmUserGroup = (data, id) => {
  let url = monitorBaseUrl + 'user_group/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteAlarmUserGroup = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'user_group/' + id + '/',
    method: 'delete'
  })
}

export const changeAlarmTemplateAction = (data, id) => {
  let url = monitorBaseUrl + 'template_action/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const getAllAlarmAllHostGroup = () => {
  return axios.request({
    url: monitorBaseUrl + 'all_host_group_list/',
    method: 'get'
  })
}

export const AlarmTemplateHostGroupBind = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'template_host_group_bind/',
    data: data,
    method: 'post'
  })
}

export const getAlarmAllUserGroupListByTemplateId = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'all_host_group_list_by_template_id/',
    params: params,
    method: 'get'
  })
}

export const getAlarmHostGroup = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'host_group/',
    params: params,
    method: 'get'
  })
}

export const detailAlarmHostGroup = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'host_group/' + id + '/',
    method: 'get'
  })
}

export const changeAlarmHostGroup = (data, id) => {
  let url = monitorBaseUrl + 'host_group/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteAlarmHostGroup = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'host_group/' + id + '/',
    method: 'delete'
  })
}

export const getMonitorEndpointList = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint_list',
    params: params,
    method: 'get'
  })
}

export const AlarmHostGroupBindHostBind = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'host_group_bind_host/',
    data: data,
    method: 'post'
  })
}

export const getAlarmPersonalInfo = () => {
  return axios.request({
    url: monitorBaseUrl + 'personal_info/',
    method: 'get'
  })
}

export const updateAlarmPersonalInfo = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'personal_info/',
    data: data,
    method: 'post'
  })
}

export const getMonitorConfig = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'config/',
    params: params,
    method: 'get'
  })
}

export const changeMonitorConfig = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'config/',
    data: data,
    method: 'post'
  })
}

export const getBaseMonitorOne = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'base_monitor_one/',
    params: params,
    method: 'get'
  })
}

export const getEventCases = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'event_cases/',
    data: params,
    method: 'post'
  })
}

export const deleteEventCases = (data, id) => {
  return axios.request({
    url: monitorBaseUrl + 'event_cases/' + id + '/',
    data: data,
    method: 'delete'
  })
}

export const getEvents = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'events/',
    params: params,
    method: 'get'
  })
}

export const getCounter = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'counter/',
    params: params,
    method: 'get'
  })
}

export const getAllCounter = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'all_counter_list/',
    params: params,
    method: 'get'
  })
}

export const detailCounter = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'counter/' + id + '/',
    method: 'get'
  })
}

export const changeCounter = (data, id) => {
  let url = monitorBaseUrl + 'counter/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteCounter = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'counter/' + id + '/',
    method: 'delete'
  })
}

export const getEndpointType = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint_type/',
    params: params,
    method: 'get'
  })
}

export const detailEndpointType = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint_type/' + id + '/',
    method: 'get'
  })
}

export const changeEndpointType = (data, id) => {
  let url = monitorBaseUrl + 'endpoint_type/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteEndpointType = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint_type/' + id + '/',
    method: 'delete'
  })
}

export const getEndpoint = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint/',
    params: params,
    method: 'get'
  })
}

export const getAllEndpoint = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'all_endpoint_list/',
    params: params,
    method: 'get'
  })
}

export const detailEndpoint = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint/' + id + '/',
    method: 'get'
  })
}

export const changeEndpoint = (data, id) => {
  let url = monitorBaseUrl + 'edit_endpoint/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteEndpoint = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint/' + id + '/',
    method: 'delete'
  })
}

export const getCounterListByEndpointIds = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'counter_list_by_endpoint_ids/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

export const CounterCollectApi = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'counter_collect/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

export const EndpointCollectApi = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'endpoint_collect/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

export const BatchDistCounterApi = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'batch_dist_counter/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

export const GetCounterByAlarmTemplateApi = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'get_counter_by_alarm_template/',
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudHeartConfig = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'heart_config/',
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllHeartConfig = () => {
  return axios.request({
    url: monitorBaseUrl + 'all_heart_config_list/',
    method: 'get'
  })
}

export const detailPrivateCloudHeartConfig = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'heart_config/' + id + '/',
    method: 'get'
  })
}

export const changePrivateCloudHeartConfig = (data, id) => {
  let url = monitorBaseUrl + 'heart_config/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deletePrivateCloudHeartConfig = (id) => {
  return axios.request({
    url: monitorBaseUrl + 'heart_config/' + id + '/',
    method: 'delete'
  })
}

export const getMonitorDashboard = () => {
  return axios.request({
    url: monitorBaseUrl + 'monitor_dashboard/',
    method: 'get'
  })
}

export const updateMonitorDashboard = (data, id) => {
  let url = monitorBaseUrl + 'monitor_dashboard/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteMonitorDashboard = (data, id) => {
  return axios.request({
    url: monitorBaseUrl + 'monitor_dashboard/' + id + '/',
    method: 'delete',
    data: data
  })
}

export const getAlarmOverView = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'alarm_over_view/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const monitorUserSync = () => {
  return axios.request({
    url: monitorBaseUrl + 'check_monitor_user_sync/',
    method: 'get'
  })
}

export const unSyncMonitorUserList = () => {
  return axios.request({
    url: monitorBaseUrl + 'un_sync_monitor_user_list/',
    method: 'get'
  })
}

export const activeStrategyApi = (data) => {
  return axios.request({
    url: monitorBaseUrl + 'active_strategy/',
    data: data,
    method: 'post'
  })
}

export const getDiskPartUseMonitorData = (params) => {
  return axios.request({
    url: monitorBaseUrl + 'disk_part_use_monitor_data/',
    params: params,
    method: 'get'
  })
}
